'use strict';
import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';

const Col = (props) => {
    const content = props.children ? props.children : "\u00a0";
    const className = classnames(props.className, `l-grid__col:${props.size}/12`);
    const style = props.style ? props.style : {};

    return <div style={style} className={className}>{content}</div>;
};

Col.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    children: PropTypes.node,
    style: PropTypes.object
};
Col.defaultProps = { size: 6 };

export default Col;